// ############################################################################
// ## SHORTCUTS ###############################################################
// ############################################################################

import $ from "jquery";
import Mousetrap from "./third-party/mousetrap";
import {compose, contains, equal, invoke, property} from "./framework/voidash";

const mousetrapStopCallback = Mousetrap.prototype.stopCallback;
Mousetrap.prototype.stopCallback = function (e, element, combo) {
  // don't stop shortcut handling when the action is "blur"
  const attr = element.getAttribute("data-shortcut");
  const regExp = new RegExp("(?:^|,\\s*)blur:" + combo.replace(/\+/g, "\\+"));
  console.log(regExp.test(attr));
  if (regExp.test(attr)) return false;
  return mousetrapStopCallback.call(Mousetrap, e, element, combo);
};

const actions = {
  click(rec) { rec.$el.get(0).click(); },
  focus(rec) { rec.$el.select(); },
  blur(rec) { rec.$el.get(0).blur(); }
};

const error = rec => { console.error(`Unknown keyboard shortcut action '${rec.action}'.`); };

const elIsVisible = compose(invoke("is", ":visible"), property("$el"));

const performAction = rec => (actions[rec.action] || error)(rec);

const persistentBindings = [];

function bindShortcuts() {
  Mousetrap.reset();

  for (const { combo, fn } of persistentBindings) {
    Mousetrap.bind(combo, fn, "keyup");
  }

  const records = [];
  $("[data-shortcut]").each(function () {
    const $el = $(this);
    $el
      .attr("data-shortcut")
      .split(/\s*,\s*/)
      .forEach(str => {
        const data = str.split(":");
        if (data.length !== 2) return;
        const [action, combo] = data;
        records.push({$el, action, combo});
      });
  });

  const combos = [];
  records.forEach(({combo}) => {
    if (!contains(combos, combo)) combos.push(combo);
  });

  Mousetrap.bind(combos, (evt, combo) => {
    let valid = records.filter(compose(equal(combo), property("combo")));

    if (valid.length > 1) {
      // on conflict take the visible one(s)
      // valid = valid.filter(rec => rec.$el.is(":visible"));
      valid = valid.filter(elIsVisible);
    }

    valid.forEach(performAction);
  });
}

export default {
  bind: (combo, fn) => {
    const colonIdx = combo.indexOf(":");
    if (colonIdx >= 0) {
      // separate the combo from expression like click:x to enable using the same expressions as global shortcuts
      combo = combo.substr(colonIdx + 1);
    }
    Mousetrap.bind(combo, fn, "keyup");
    persistentBindings.push({ combo, fn });
  },

  rescanDocument() {
    bindShortcuts();
  }
};

$(function () {
  bindShortcuts();

  try {
    AJAX.onUpdate(bindShortcuts);
  } catch (e) {
    console.error("Failed to bind keyboard shortcuts rebinding on AJAX update.", e);
  }
});
